/**
 * Safely coerce a FastAPI-style `error.response.data.detail` field to a
 * displayable string. FastAPI returns `detail` as either a string or an
 * arbitrary JSON object (e.g. our trial-ended 403 returns
 * `{reason, workspace_id, owner_email, trial_ended_at}`). Rendering an
 * object as a React child crashes the tree via ErrorBoundary
 * ("Objects are not valid as a React child"), so every error-detail
 * call site MUST funnel through here before showToast / setError / JSX.
 *
 * Resolution order:
 *   1. string → return as-is.
 *   2. object → prefer `reason` (our backend's primary key), then
 *      `message` (Pydantic / generic), else the provided fallback.
 *   3. anything else (null/undefined/array/number) → fallback.
 */
export const detailMessage = (
    detail: unknown,
    fallback = 'Request failed',
): string => {
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
        const obj = detail as Record<string, unknown>;
        if (typeof obj.reason === 'string') return obj.reason;
        if (typeof obj.message === 'string') return obj.message;
    }
    return fallback;
};
